import { t } from '@lingui/macro';

// free trial state is ongonig
export const FREE_TRIAL_IN_USE = 'in_use';

// probably user is not eligible for free trial state anymore, should be double checked with policies
export const FREE_TRIAL_STATE_USED = 'used';

// user is eligible for free trial
export const FREE_TRIAL_STATE_UNUSED = 'unused';

export const CANCEL_REASONS = [
    {
        id: 'cant-find-songs',
        label: t`I can't find my favourite songs`,
    },
    {
        id: 'no-time',
        label: t`I don't have time to play`,
    },
    {
        id: 'not-getting-better',
        label: t`I'm not getting any better`,
    },
    {
        id: 'few-features',
        label: t`Yousician doesn't have all the features I need`,
    },
    {
        id: 'save-money',
        label: t`I'm trying to save money`,
    },
    {
        id: 'other',
        label: t`Other reason (give us feedback)`,
    },
];

export const GATEWAY_ITUNES = 'itunes';
export const GATEWAY_ADYEN = 'adyen';
export const GATEWAY_GOOGLEPLAY = 'googleplay';

export const FREE_TRIAL_CTAS = t`Try free for 7 days`;

export const FAMILY_PLAN_MEMBERS = 4;

export const TRIAL_DISCOUNTS: {
    [key: string]: { token: string; percentage: number; name: string };
} = {
    '6GWGALJM': {
        token: '6GWGALJM',
        percentage: 15,
        name: 'savusauna_6GWGALJM',
    },

    v1kDRXO7: {
        token: 'v1kDRXO7',
        percentage: 25,
        name: 'savusauna_v1kDRXO7',
    },

    E3Lo7Lwx: {
        token: 'E3Lo7Lwx',
        percentage: 33,
        name: 'savusauna_E3Lo7Lwx',
    },
};
export const PLAN_DURATIONS = ['yearly', 'quarterly', 'monthly', 'weekly'];
export const PLAN_TYPES = ['premium', 'licensed', 'family', 'all'];
